import req from './../../../../../fetch';
import { undocumentedResponse, paramsToString } from './../../../../../utils';
import {
  AllAPIResponses,
  CarbonError,
  ReactionType,
} from './../../../../../index';

type Params = {
  all?: boolean;
  email: string;
};
const get = async (
  token: string,
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<ReactionType[]>> => {
  try {
    const resp = await req.get(
      `/api/usersubscriptions/unsubscribe/${token}${paramsToString(params)}`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as ReactionType[],
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
